module.exports = __webpack_public_path__ + "static/media/x-circle-dark.c479e324.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/x-circle-dark.svg
// module id = 1993
// module chunks = 70